import React, { useContext } from "react";
import { Box, Grid } from "@material-ui/core";

import { MatchContext } from "../../context";
import Graph from "../graph/graph.component";

const GraphsContainer = ({ handleSensorChange }): JSX.Element => {
  const { state } = useContext(MatchContext);

  const prepareGraph = (id: string) => {
    return (
      <Graph
        handleSensorChange={handleSensorChange}
        value={state.graphSensor[id]}
        dataId={id}
      />
    );
  };

  return (
    <div className="content">
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            {prepareGraph("GRAPH1")}
          </Grid>
          <Grid item xs={6}>
            {prepareGraph("GRAPH2")}
          </Grid>
          <Grid item xs={6}>
            {prepareGraph("GRAPH3")}
          </Grid>
          <Grid item xs={6}>
            {prepareGraph("GRAPH4")}
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default GraphsContainer;
